export const ConnectorStatus = {
  /** Leg has been flown — connector filled with step color. */
  DONE: 'done',
  /** Leg currently being flown — pulses between step color and gray. */
  ACTIVE: 'active',
  /** Not yet reached — gray static connector. */
  NOT_DONE: 'not_done'
} as const;

export type ConnectorStatus = (typeof ConnectorStatus)[keyof typeof ConnectorStatus];
